import React, { useEffect, useState } from 'react';
import GridColumn from '@navi/web-ui/lib/layouts/Grid/GridColumn/GridColumn';
import GridRow from '@navi/web-ui/lib/layouts/Grid/GridRow/GridRow';
import { Drawer } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import { AgTable, Pagination } from '@navi/web-ui/lib/components';
import { GenericObject } from '@cp/src/types/CommonConstans';
import { DropDownPosition } from '@cp/src/pages/AmeyoUtility/types';
import styles from './UploadHistoryDrawer.module.scss';

interface UploadHistoryComponentProps {
  showUploadHistoryComponent: boolean;
  setShowUploadHistoryComponent: React.Dispatch<React.SetStateAction<boolean>>;
  data: GenericObject;
  columnDefs: any;
  fetchUploadHistory: (pageNo: number, pageSize: number, type?: string, status?: string) => void;
  headerText?: string;
  typeOfUpload?: string;
  width?: string;
  status?: string;
  pageSize?: number;
  rowHeight?: number;
  showPagination?: boolean;
  pages?: {
    totalElements?: number;
    totalPages?: number;
    number?: number;
    size?: number;
  };
}

const DEFAULT_PAGE_NUMBER = 1;
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_DRAWER_WIDTH = '820px';
const DEFAULT_ROW_HEIGHT = 48;

const UploadHistoryDrawer = (props: UploadHistoryComponentProps) => {
  const {
    showUploadHistoryComponent,
    setShowUploadHistoryComponent,
    data,
    columnDefs,
    fetchUploadHistory,
    headerText = 'Upload History',
    typeOfUpload = '',
    width = DEFAULT_DRAWER_WIDTH,
    status = '',
    pageSize: initialPageSize = DEFAULT_PAGE_SIZE,
    rowHeight = DEFAULT_ROW_HEIGHT,
    showPagination = true,
    pages
  } = props;

  const [pageSize, setPageSize] = useState(initialPageSize);
  const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);

  const handleOnPageChange = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  const handleOnPageSizeChange = (pageSize: number) => {
    setPageSize(pageSize);
    setPageNumber(1);
  };

  useEffect(() => {
    if (!showUploadHistoryComponent) {
      return;
    }
    fetchUploadHistory(pageNumber - 1, pageSize, typeOfUpload, status);
  }, [pageNumber, pageSize, showUploadHistoryComponent, typeOfUpload, status]);

  return (
    <div>
      <Drawer
        headerText={headerText}
        onClose={() => setShowUploadHistoryComponent(false)}
        open={showUploadHistoryComponent}
        style={{ width: width }}
        contentClasses="overflow-auto"
        usePadding={false}
      >
        <GridRow className="no-gutters">
          <GridColumn md={12} className={cx(styles.Table__table, 'no-gutters')}>
            <AgTable
              defaultColDef={{
                suppressMovable: true,
                wrapText: true,
                autoHeight: true
              }}
              className="uploadHistoryTable"
              rowData={data || []}
              columnDefs={columnDefs}
              headerHeight={28}
              rowHeight={rowHeight}
              theme={'alpine'}
              sizeColumnsToFit={true}
              getAgRowStyle={() => {
                return { color: 'var(--grayscale-2)' };
              }}
              paginationWrapperClasses={'paginationWrapperClasses'}
              PaginationComponent={
                showPagination ? (
                  <Pagination
                    totalCount={pages?.totalElements || 0}
                    onPageChange={handleOnPageChange}
                    currentPage={pageNumber}
                    onPageSizeChange={handleOnPageSizeChange}
                    pageSize={pageSize}
                    pageNumberDropDownPosition={DropDownPosition.TOP}
                    containerClasses="paginationContainerClass"
                  />
                ) : null
              }
            />
          </GridColumn>
        </GridRow>
      </Drawer>
    </div>
  );
};

export default UploadHistoryDrawer;
